import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  initializeFirestore,
  getFirestore,
  Firestore,
  FirestoreSettings,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyDlbcm7DpY9ZqunelqxPUreQtjP7P5sw2s',
  authDomain: 'minipt-1.firebaseapp.com',
  databaseURL: 'https://minipt-1-default-rtdb.firebaseio.com',
  projectId: 'minipt-1',
  storageBucket: 'minipt-1.firebasestorage.app',
  messagingSenderId: '975043765451',
  appId: '1:975043765451:web:8c23140dcd9bab954ca74e',
  measurementId: 'G-1P25DVDH56',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const isSafariBrowser = (): boolean => {
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return false;
  }
  const ua = navigator.userAgent.toLowerCase();
  const isChromeOrChromium = /chrome|chromium|crios|android/i.test(ua);
  const isFirefox = /firefox|fxios/i.test(ua);
  const isEdge = /edg/i.test(ua);
  const isSafari = /safari/i.test(ua) && !isChromeOrChromium && !isFirefox && !isEdge;
  const isIOS =
    /iphone|ipad|ipod/i.test(ua) && /webkit/i.test(ua) && !isChromeOrChromium && !isFirefox;

  return Boolean(isSafari || isIOS);
};

const firestoreSettings: FirestoreSettings = {
  ignoreUndefinedProperties: true,
  ...(isSafariBrowser() ? { experimentalForceLongPolling: true } : {}),
};

let firestoreInstance: Firestore;
try {
  firestoreInstance = initializeFirestore(app, firestoreSettings);
} catch {
  firestoreInstance = getFirestore(app);
}

export const db = firestoreInstance;
export const storage = getStorage(app);

// If you ever want to use the local emulator, you can uncomment this block:
// if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
//   connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
//   connectFirestoreEmulator(db, '127.0.0.1', 9000);
// }
